/* eslint-disable react/prop-types */

import SoftBadge from "components/common/SoftBadge";
import React from "react";

const SDUserBadge = ({ user }) => {
    if (user) {
        if (user.role && user.role == "Agent") {
            return <SoftBadge pill bg='primary' className='me-2'>Agent</SoftBadge>
        }
        else if (user.role && user.role == "Admin") {
            return <SoftBadge pill bg='warning' className='me-2'>Admin</SoftBadge>
        } else {
            return <SoftBadge pill bg='secondary' className='me-2'>Customer</SoftBadge>
        }
    }

    return <></>

}

export default SDUserBadge;